/** The reply-to a new organization is offered: its own e-mail, until someone types another. */
export function offeredReplyTo(email: string, replyTo: string, edited: boolean): string {
  return edited ? replyTo : email.trim()
}
